import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChipModule } from 'primeng/chip';
import { NodeHelper } from '../../../services/helpers/node.helper';
import { IBluePrintNodeModel } from '../../../models/blueprint/blueprint-node.model';

/**
 * NodeTypeMenuComponent
 *
 * Presentational mat-menu listing blueprint node types as colored chips.
 * Shared by the top Create button and the per-column "+ Add Item" button so
 * the two type lists can never drift apart. Callers supply their own trigger
 * button and wire it via `[matMenuTriggerFor]="ref.menu"`, then handle
 * `(typeSelected)`.
 */
@Component({
  selector: 'app-node-type-menu',
  standalone: true,
  imports: [CommonModule, MatMenuModule, MatTooltipModule, ChipModule],
  templateUrl: './node-type-menu.component.html',
  styleUrls: ['./node-type-menu.component.css'],
})
export class NodeTypeMenuComponent {
  @Input() nodeTypes: IBluePrintNodeModel[] = [];
  @Output() typeSelected = new EventEmitter<string>();

  @ViewChild('menu') menu!: MatMenu;

  constructor(protected nodeHelper: NodeHelper) {}

  public onSelect(nodeTypeName: string | undefined): void {
    if (nodeTypeName) {
      this.typeSelected.emit(nodeTypeName);
    }
  }
}
